<template>
  <b-modal
    :id="`turn-bank-account-primary-${account.id}`"
    :modal-class="modalClasses"
    :hide-footer="true"
    ref="turnBankAccountPrimary"
    @hidden="hide"
  >
    <template v-slot:modal-title>
    </template>

    <template v-slot:default>
      <AlertWraper
        :content="errors"
        type="error"
      />
      <div class="text-center">
        <BaseIcon
          size="medium"
        >
          <WarningIcon />
        </BaseIcon>
        <h2 class="font-weight-bold font-size-medium text-color2">Atenção!</h2>
        <p>Você tem certeza que quer tornar a conta bancária <strong class="text-color2">{{ account.account }}</strong> do banco <strong>{{ account.bank.name }}</strong> como conta principal?</p>
        <p class="font-size-small">
          <strong>Atenção:</strong> Ao mudar a sua conta principal, todos os pagamentos pendentes serão feitos nessa nova conta.
        </p>
        <div class="mt-4">
          <Button
              class="btn-primary btn-sm mr-2"
              :loading="loader"
              @click="submit"
            >
            Confirmar
          </Button>
          <Button
            class="btn-outline-color2 btn-sm"
            @click="hide"
          >
            Cancelar
          </Button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>

import BankAccountsService from '@/modules/bank-accounts/services/bank-accounts-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { parseErrorResponseToArray } from '@/utils'
import { mapState } from 'vuex'

import AlertWraper from '@/components/common/Alert/AlertWraper.vue'
import BaseIcon from '@/components/common/Icon/BaseIcon.vue'
import Button from '@/components/common/Button/Button.vue'
import WarningIcon from '@/components/common/Icon/WarningIcon.vue'

export default {
  name: 'TurnBankAccountPrimaryModal',
  props: ['account'],
  components: {
    AlertWraper,
    BaseIcon,
    Button,
    WarningIcon
  },
  data () {
    return {
      errors: null,
      loader: false
    }
  },
  computed: {
    ...mapState({
      nightMode: state => state.nightMode
    }),
    modalClasses () {
      return {
        'default-modal': true,
        'modal-small': true
      }
    }
  },
  methods: {
    async submit () {
      this.errors = null
      this.loader = true
      try {
        await BankAccountsService.turnPrimary(this.account.id)
        this.$bvModal.hide(`turn-bank-account-primary-${this.account.id}`)
        const notification = {
          notification: {
            type: 'success',
            content: 'Conta bancária principal alterada com sucesso'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$emit('bank-account-turned-primary')
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    hide () {
      this.errors = null
      this.$bvModal.hide(`turn-bank-account-primary-${this.account.id}`)
    }
  }
}
</script>
